if (!customElements.get('pawce-editorial')) {
 customElements.define('pawce-editorial', class extends HTMLElement {
  connectedCallback() {
   this.controller=new AbortController();
   const options={signal:this.controller.signal,passive:true};
   let scheduled=false;
   const update=()=>{
    scheduled=false;
    const range=document.documentElement.scrollHeight-innerHeight;
    const progress=range>0?Math.min(1,Math.max(0,scrollY/range)):0;
    this.querySelector('[data-reading-progress]').style.transform=`scaleX(${progress})`;
    const offer=this.querySelector('.pe-offer').getBoundingClientRect();
    this.querySelector('[data-article-sticky]').hidden=progress<.16||(offer.top<innerHeight&&offer.bottom>0);
   };
   const schedule=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(update);}};
   window.addEventListener('scroll',schedule,options);
   window.addEventListener('resize',schedule,options);
   update();
  }
  disconnectedCallback(){this.controller?.abort();}
 });
}
